import React from 'react';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';


import PalletSummaryInfo from "./PalletSummaryInfo";
import PalletSummaryJobs from "./PalletSummaryJobs";

const PalletSummary = ({pallet, lastPallet, jobs=true, ...props}) => {

    const [value, setValue] = React.useState(0);

    function handleChange(event, newValue) {
        setValue(newValue);
    }

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={0}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }

    return (
        <Box >
            <Tabs
                value={value}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
                centered
            >
                <Tab label="Summary"></Tab>
                {jobs && (<Tab label="Jobs" ></Tab>)}
            </Tabs>
            <TabPanel value={value} index={0}>
                <PalletSummaryInfo pallet={pallet} lastPallet={lastPallet}/>
            </TabPanel>
            {jobs && (
            <TabPanel value={value} index={1}>
                <PalletSummaryJobs jobs={pallet.jobs ? pallet.jobs : []} />
            </TabPanel>)}
        </Box>
    )

}

export default PalletSummary;